import type { Workflow } from '@fv/models'

export const workflowLabels: Record<Workflow, string> = {
  ltl: 'LTL',
  parcel: 'Parcel',
  truckload: 'Truckload',
}
